export default "__VITE_ASSET__CZzSVo5h__"